import { FormEvent, useEffect, useState } from 'react';
import { Alert, Button, ControlLabel, FormControl, FormGroup, Modal } from 'react-bootstrap';

interface IProps {
    show: boolean,
    onConfirmRequest: (message: string) => void,
    onCancel: () => void
}

const InfoRequest = (props: IProps) => {
    const [message, setMessage] = useState('');
    const [isMessageValid, setMessageValid] = useState(true);
    const [isDirty, setDirty] = useState(false);

    const handleMessageChange = (e: FormEvent<FormControl & HTMLTextAreaElement>) => {
        setMessage(e.currentTarget.value);
    }

    const handleConfirmRequest = () => {
        let isMessageValid = message != '';

        setMessageValid(isMessageValid);
        setDirty(true);

        if (isMessageValid) {
            props.onConfirmRequest(message);
        }
    }

    useEffect(() => {
        if (props.show) {
            setMessage('');
            setMessageValid(true);
            setDirty(false);
        }
    }, [props.show]);

    return (
        <Modal show={props.show} backdrop='static' onHide={props.onCancel}>
            <Modal.Header closeButton>
                <Modal.Title>General Info Request</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {isDirty && !isMessageValid && (
                    <Alert bsStyle='danger'>
                        You must specify additional information before submitting your request
                    </Alert>
                )}

                <FormGroup validationState={isDirty && !isMessageValid ? 'error' : null}>
                    <ControlLabel>Please specify the additional information you are requesting</ControlLabel>
                    <FormControl
                        componentClass='textarea'
                        style={{ resize: 'none', height: 100 }}
                        value={message}
                        onChange={handleMessageChange}
                    />
                </FormGroup>
            </Modal.Body>

            <Modal.Footer>
                <Button bsStyle='primary' onClick={handleConfirmRequest}>Confirm Request</Button>
                <Button onClick={props.onCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default InfoRequest;